import { render, staticRenderFns } from "./BangTinhTienTraCoc.vue?vue&type=template&id=c68db162&"
import script from "./BangTinhTienTraCoc.vue?vue&type=script&lang=js&"
export * from "./BangTinhTienTraCoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports